const $ = window.jQuery;

module.exports = {

    init: function () {
        /* Mobile Nav Menu - from https://www.wpbeginner.com/wp-themes/how-to-create-a-mobile-ready-responsive-wordpress-menu/ */
        // console.log('mobile nav menu');
        var nav = document.getElementById('header-navigation'),
            button, menu;
        if (!nav) {
            return;
        }

        button = document.getElementById('mobile-menu-btn');
        menu = nav.getElementsByTagName('ul')[0];
        if (!button) {
            return;
        }

        // Hide button if menu is missing or empty.
        if (!menu || !menu.childNodes.length) {
            button.style.display = 'none';
            return;
        }

        button.onclick = function () {
            if (-1 === menu.className.indexOf('nav-menu')) {
                menu.className = 'nav-menu';
            }

            if (-1 !== button.className.indexOf('toggled-on')) {
                button.className = button.className.replace(' toggled-on', '');
                menu.className = menu.className.replace(' toggled-on', '');
                $('#whole-nav-container').removeClass('bg-indigo');
                $('#susie-logo').removeClass('hidden');

            } else {
                button.className += ' toggled-on';
                menu.className += ' toggled-on';
                $('#whole-nav-container').addClass('bg-indigo');
                $('#susie-logo').addClass('hidden');
            }
        };

        // Set padding on the page header 
        var setHeaderPadding = function () {
            var headerHeight = $('header').height();
            $('.main-content-header ').css("padding-top", headerHeight);
        }

        var checkScreenSize = function () {
            if ($(window).width() < 768) {
                $('#header-navigation').addClass('mobileMenu');
                $('.sub-menu').addClass('hideSubMenu');
                $('.mobileMenu .nav-menu .menu-item-has-children>a').off('click').on('click', function (e) {
                    e.preventDefault();
                    var menuLinkID = e.target.parentElement.id;
                    var subMenu = '#' + menuLinkID + '>ul.sub-menu';
                    if ($(subMenu).hasClass('hideSubMenu')) {
                        $('.mobileMenu ' + subMenu).removeClass('hideSubMenu').addClass('showSubMenu');
                        $('#' + menuLinkID + '>a').addClass('upChevron');
                    } else {
                        $('#' + menuLinkID + '>a').removeClass('upChevron');
                        $('.mobileMenu ' + subMenu).removeClass('showSubMenu').addClass('hideSubMenu');
                    }
                });
            } else {
                // console.log('mobile menu hidden ');
                $('#menu-main-menu').removeClass('toggled-on');
                $('#mobile-menu-btn').removeClass('toggled-on');
                $('#header-navigation').removeClass('mobileMenu');
                $('.sub-menu').removeClass('showSubMenu hideSubMenu').removeAttr('style');
                $('a').removeClass('upChevron');
                $('.nav-menu .menu-item-has-children>a').off('click');
                $('.sub-menu').addClass('hideSubMenu');
                
            }
            setHeaderPadding();
        }

        checkScreenSize();
        $(window).on('resize', checkScreenSize);

        // Flyout menu mouseover functionality for accessibility: https://www.w3.org/WAI/tutorials/menus/flyout/#mouse-users
        // var menuItems = document.querySelectorAll('li.menu-item-has-children');
        // Array.prototype.forEach.call(menuItems, function(el, i){
        //     el.addEventListener("mouseover", function(event){
        //         this.className = "menu-item-has-children open";
        //         // if(typeof timer !== 'undefined'){
        //         //     clearTimeout(timer);
        //         // }
        //     });
        //     el.addEventListener("mouseout", function(event){
        //         timer = setTimeout(function(event){
        //             var openMenuItem = document.querySelector(".menu-item-has-children.open");
        //             if(openMenuItem){
        //                 openMenuItem.className = "menu-item-has-children";
        //             }
        //         }, 1000);
        //     });
        // });

        // Flyout menu keyboard functionality for accessibility: https://www.w3.org/WAI/tutorials/menus/flyout/#use-parent-as-toggle
        var menuItems = document.querySelectorAll('li.menu-item-has-children');
        Array.prototype.forEach.call(menuItems, function(el, i){
            el.querySelector('a').addEventListener("click",  function(event){
                if (this.parentNode.className == "menu-item-has-children") {
                    this.parentNode.className = "menu-item-has-children open";
                    this.setAttribute('aria-expanded', "true");
                } else {
                    this.parentNode.className = "menu-item-has-children";
                    this.setAttribute('aria-expanded', "false");
                }
                event.preventDefault();
                return false;
            });
        });

        // Position the top of the submenus
        $('.site-navigation ul.nav-menu li.menu-item-has-children').on( "mouseover", function() {
            var elementOffsetTop = this.offsetTop;
            $(this).children('ul.sub-menu').css("top", 53+elementOffsetTop);
        });
         

        // Menu search form: show on click of search icon
          function showSearchForm() {
            $(".search-icon").on('click',function () {
                $(".wpsearchform").slideToggle();
                $("#menu-main-menu > li.search.menu-item > div > form > input.search-field").focus();
            });

            $(document).keydown(function (e) {
                if (e.keyCode == 27) {
                    $(".wpsearchform").hide();
                }
            });
        }

        $("input.search-field").val('');

            showSearchForm();
    },

};